// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__msIvV","footer":"ModalError_footer__23BOb"};